import { useField } from "formik";
import { useContext } from "react";
import { RfxContext } from "newui/features/Rfx/context/RfxContext";

export const useSmartFieldSelection = (props, options = {}) => {
	const { shouldSubmit = false } = options;
	// eslint-disable-next-line
	const [field, meta, helper] = useField(props);
	const { value, error, touched } = meta;
	const { setValue, setTouched } = helper;
	const { saveHandler } = useContext(RfxContext);

	// // extract ID: "question_answer.question-2143" -> "2143")
	// const questionId = props.name?.split("-")[1];

	const isSelected = (listValue) =>
		Array.isArray(value) && value.length > 0
			? value.includes(listValue)
			: false;

	const selectHandler = async (listValue) => {
		setTouched(true);
		let updated;
		if (isSelected(listValue)) {
			updated = value.filter((val) => val !== listValue);
		} else {
			updated = Array.isArray(value) ? [...value, listValue] : [listValue];
		}
		setValue(updated);
		if (shouldSubmit && saveHandler) {
			setTimeout(async () => {
				await saveHandler();
			}, 0);
		}
	};

	return {
		value,
		error,
		touched,
		isSelected,
		selectHandler,
		isSubmitting: false,
	};
};
